<!--
 * @Date: 2022-08-22 11:28:17
 * @LastEditors: asahi
 * @LastEditTime: 2023-12-07 10:40:27
 * @FilePath: \dataview-next\src\custom-component\viewerBIM\ViewerBIM.vue
-->
<template>
    <article class="bimViewer-cont">
        <div ref="viewerMarkDom" class="mask" v-show="setting.showMask"></div>
        <!-- <bim-modellist
                ref="modellist"
                @loadModel="loadModel"
                @unloadModel="unloadModel"
                @fitToView="fitToModel"
        ></bim-modellist> -->
        <div ref="viewerDom" class="bimviewer_main"></div>
        <bim-toolbar ref="toolbar"></bim-toolbar>
    </article>
</template>

<script>
    import ComponentFactory from "./ComponentFactory";
    const cf = new ComponentFactory();

    export default cf.generate();
</script>

<style scoped>
    .bimviewer_main{
        height: 100%;
        width: 100%;
    }
    .mask{
        height: 100%;
        width: 100%;
        position: absolute;
        z-index: 999;
    }
</style>
